export const templateOfTextFourColumnsBlock = `
    <div class="row content-block">
        <div class="col-6 col-lg-3 column px-8 py-4">
            <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
        </div>
        <column-separator></column-separator>
        <div class="col-6 col-lg-3 column px-8 py-4">
            <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
        </div>
        <column-separator></column-separator>
        <div class="col-6 col-lg-3 column px-8 py-4">
            <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
        </div>
        <column-separator></column-separator>
        <div class="col-6 col-lg-3 column px-8 py-4">
            <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
        </div>
    </div>
`
